export default __webpack_public_path__ + "static/media/fiducia-logo.aeff0340.jpg";